import { ContentSection } from "../components/ContentSection";
import { HeroSection } from "../components/HeroSection";

export default function HomePage() {

  return (
    <>
      <HeroSection />
      <ContentSection />
    </>
  );
}